import PropTypes from 'prop-types';
import { ButtonV2, Typography } from '@vartanainc/design-system';

/**
 * The small tile shown for each Integration
 */
function IntegrationCard({
  integration,
  onClick,
  onDeactivate,
  imageIcon,
  inSettingsPage,
  buttonLabel,
}) {
  const { id, title, isActive, description } = integration;

  return (
    <div
      className={`w-full flex flex-col p-6 border border-vartana-steel-40 rounded-md justify-between gap-6 ${
        inSettingsPage ? '' : 'max-w-max'
      }`}
      id={id}
    >
      <div className="flex flex-col gap-6">
        <div
          className={`${
            inSettingsPage ? 'gap-2' : 'flex-col gap-6'
          } flex  justify-between items-center w-full`}
        >
          <div className="h-8 ">{imageIcon}</div>
          {isActive && <span className="pill success">Active</span>}
        </div>
        <div className="flex flex-col gap-2">
          <Typography variant="paragraph14" bold color="color-gray-160">
            {title}
          </Typography>
          <Typography variant="paragraph12" color="color-black-100">
            {description}
          </Typography>
        </div>
      </div>
      {buttonLabel && (
        <div className="flex flex-col gap-4 max-w-max">
          <ButtonV2
            variant={{ type: 'primary', typography: 'paragraph12' }}
            text={buttonLabel}
            onClick={onClick}
          />
        </div>
      )}
      {inSettingsPage &&
        !buttonLabel &&
        (isActive ? (
          <div className="flex items-center gap-4 w-full flex-wrap">
            <ButtonV2
              variant={{ type: 'secondary', typography: 'paragraph12' }}
              text="Reconfigure"
              onClick={onClick}
            />
            <ButtonV2
              variant={{ type: 'ghost', typography: 'paragraph12' }}
              text="Deactivate"
              onClick={() => onDeactivate(integration)}
            />
          </div>
        ) : (
          <div className="flex flex-col gap-4 max-w-max">
            <ButtonV2
              variant={{ type: 'primary', typography: 'paragraph12' }}
              text="Add integration"
              onClick={onClick}
            />
          </div>
        ))}
    </div>
  );
}

IntegrationCard.propTypes = {
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    iconUrl: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  imageIcon: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func,
  inSettingsPage: PropTypes.bool,
  buttonLabel: PropTypes.string.isRequired,
};

IntegrationCard.defaultProps = {
  onDeactivate: () => {},
  inSettingsPage: false,
};

export default IntegrationCard;
